    <!-- Invoice History -->
    <section class="invoice-history">
      <h2>Invoice History</h2>
      <div *ngIf="!hasInvoices">No invoices found</div>
      <table *ngIf="this.hasInvoices">
        <thead>
          <tr>
            <th>Date</th>
            <th>Invoice number</th>
            <th>Amount</th>
            <th>Due date</th>
            <th>Period</th>
            <th>Status</th>
            <th>Download</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of invoices()">
            <td>{{item.createdAt | date}}</td>
            <td>{{item.invoice_number}}</td>
            <td>{{item.including_tax | currency: 'USD'}}</td>
            <td>{{item.due_date | date}}</td>
            <td>{{item.lines.data[0].period_start | date}}</td>
            <td><span class="status" [ngClass]="{'paid': item.status === 'PAID' || item.status === 'PAID_1'}">{{item.status}}</span></td>
            <td><a [href]="item.document_url" target="_blank" class="download-link">Download</a></td>
          </tr>
        </tbody>
      </table>
    </section>
